import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";

import StudentHomePageView from "./StudentHomePage.View";
import StudentHomePageViewModel from "./StudentHomePage.ViewModel";

export function StudentHomePage() {
    const _viewModel = StudentHomePageViewModel();

    // @ts-ignore
    const userData = useSelector((state) => state.user.credentials);

    //#region States
    const [showNotificationModal, setShowNotificationModal] = useState(false);
    const [books, setBooks] = useState([]);
    const [barcode, setBarcode] = useState({
        currentBarcode: 0,
        classNumber: "",
        id: "",
        isCompleted: false,
        userId: "",
        year: 0,
    });
    const [dates, setDates] = useState({
        end: "",
        returnLocation: "",
        start: "",
    });
    const [loading, setLoading] = useState(true);

    //#endregion

    //#region Effect Hooks
    useEffect(() => {
        _viewModel.checkNotification(setShowNotificationModal);
    }, [userData.showAdvice]);

    useEffect(() => {
        _viewModel.getSummary(setBooks, setDates, setBarcode, setLoading);
    }, [userData.currentBarcode]);

    //#endregion

    //#region Handlers
    function handleStudentHeaderUpdate() {
        return _viewModel.updateBook(books, setBooks, setDates, setBarcode, setLoading);
    }

    function handleStudentHeaderComplete() {
        return _viewModel.completeBooks(setBooks, setDates, setBarcode, setLoading);
    }

    function handleNotificationModalHide() {
        return setShowNotificationModal(false);
    }

    function handleStatusCellUpdateBook() {
        return _viewModel.updateBook(books, setBooks, setDates, setBarcode, setLoading);
    }

    //#endregion

    return (
        <StudentHomePageView
            dates={dates}
            barcode={barcode}
            books={books}
            loading={loading}
            onStudentHeaderUpdate={handleStudentHeaderUpdate}
            onStudentHeaderComplete={handleStudentHeaderComplete}
            onNotifModalHide={handleNotificationModalHide}
            showNotificationModal={showNotificationModal}
            onStatusCellUpdateBook={handleStatusCellUpdateBook}
        />
    );
}
